var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdmin = function SvgAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68164 6.85662C5.68164 4.47177 7.61497 2.53844 9.99982 2.53844C12.3847 2.53844 14.318 4.47177 14.318 6.85662C14.318 9.24147 12.3847 11.1748 9.99982 11.1748C7.61497 11.1748 5.68164 9.24147 5.68164 6.85662Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9577 13.3347C16.6846 13.9734 17.0984 14.8961 17.0984 15.8638V17.112C17.0984 17.8573 16.4942 18.4614 15.7489 18.4614H4.25178C3.50652 18.4614 2.90234 17.8573 2.90234 17.112V15.8638C2.90234 12.4806 7.32659 11.1745 10.0004 11.1745",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
export default SvgAdmin;